import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';
import { ironcladConnectionUrlSchema } from './lib/instance-url';

export type IroncladConnectorConfig = typeof IroncladConnector._.Config;

export const IroncladConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Ironclad,
  logoPath: 'images/ironclad-logo.svg',
  categories: [IntegrationConnectorCategory.Agreements],
  auths: IntegrationAuth.group([
    IntegrationAuth.manual({
      name: Integration_Auth_Names_Enum.ServiceAccountOauth,
      configSchema: z.object({
        instanceUrl: ironcladConnectionUrlSchema,
        actingUserEmail: z.email(),
        clientId: z.string().trim().min(1),
      }),
      encryptedConfigSchema: z.object({
        clientSecret: z.string().trim().min(1),
      }),
    }),
  ]),
});
